<h1 mat-dialog-title>Confirm Deletion</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete this file?</p>
  <!-- <mat-form-field appearance="fill" style="width: 550px;">
    <mat-label>Comments</mat-label>
    <textarea matInput [(ngModel)]="comments" rows="4" required></textarea>
   </mat-form-field> -->
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button (click)="onConfirm()">Confirm</button>
</div>